import {Button} from "@material-ui/core";
import {buttonsStyle} from "./styles";
import {MinLoader} from "../loader";
import {Colors} from "utils";
import React from "react";

export const ChancelModalButton = ({text, handleClick, styles, loading, type}) => {
    const classes = buttonsStyle();
    return (
        <div style={styles}>
            <Button className={classes.chancelModalButtonStyle} onClick={handleClick}>
                {loading === true ?
                    <MinLoader margin={'0'} color={Colors.TextWhite}/>
                    :
                    text
                }
            </Button>
        </div>
    );
};
